import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Clock, CreditCard } from 'lucide-react';
import { Button } from './ui/Button';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-white relative overflow-hidden" data-id="element-142">
      <div className="absolute top-0 left-0 w-full h-1/2 bg-cream -z-10" data-id="element-143"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-teal overflow-hidden relative" data-id="element-145">
          <div className="bg-teal text-white text-center py-3 font-bold tracking-wide uppercase text-sm" data-id="element-146">
            Precio Especial de Lanzamiento
          </div>

          <div className="p-8 md:p-12" data-id="element-147">
            <div className="text-center mb-8" data-id="element-148">
              <h2 className="text-3xl md:text-4xl font-bold text-slate mb-4" data-id="element-149">
                Obtén el Protocolo "Pañal Adiós" (3 Días) hoy mismo.
              </h2>
              <p className="text-xl text-slate-light" data-id="element-150">
                Recupera tu tranquilidad, ahorra dinero y dale a tu hijo la
                confianza que merece.
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-151">
              <div className="text-center" data-id="element-152">
                <span className="text-slate-light line-through text-2xl block mb-1" data-id="element-153">
                  Valor: $25 USD
                </span>
                <div className="flex items-start justify-center text-teal" data-id="element-154">
                  <span className="text-3xl font-bold mt-2" data-id="element-155">$</span>
                  <span className="text-7xl font-black leading-none" data-id="element-156">6.36</span>
                  <span className="text-xl font-bold mt-2 ml-1" data-id="element-157">USD</span>
                </div>
              </div>
            </div>

            <div id="offer-cta" className="max-w-md mx-auto mb-10 scroll-mt-24" data-id="element-158">
              <Button fullWidth className="py-5 text-xl" onClick={() => {
              if (typeof window !== 'undefined' && window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_ids: ['43911763132481'],
                  content_type: 'product',
                  value: 10.99,
                  currency: 'USD'
                });
              }
              window.location.href = 'https://ofertavital.com/cart/43911763132481:1';
            }} data-id="element-159">
                ¡QUIERO EMPEZAR EL PROTOCOLO AHORA!
              </Button>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-light font-medium" data-id="element-160">
              <div className="flex items-center gap-2" data-id="element-161">
                <Clock size={18} className="text-teal" data-id="element-162" />
                <span data-id="element-163">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-164">
                <Shield size={18} className="text-teal" data-id="element-165" />
                <span data-id="element-166">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-167">
                <CreditCard size={18} className="text-teal" data-id="element-168" />
                <span data-id="element-169">Garantía de satisfacción</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}